export function showSuccessBar(enqueueSnackbar, msg, persist=false) {
  enqueueSnackbar(msg, {'variant': 'success', 'persist': persist})
}
export function showErrorBar(enqueueSnackbar, msg, persist=false) {
  enqueueSnackbar(msg, {'variant': 'error', 'persist': persist})
}
export function showInfoBar(enqueueSnackbar, msg, persist=false) {
  enqueueSnackbar(msg, {'variant': 'info', 'persist': persist})
}
